/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconAndroidEN from '@telus-uds/palette-koodo/build/rn/icons/AndroidEN'
import PaletteIconAndroidFR from '@telus-uds/palette-koodo/build/rn/icons/AndroidFR'
import PaletteIconIOSEN from '@telus-uds/palette-koodo/build/rn/icons/IOSEN'
import PaletteIconIOSFR from '@telus-uds/palette-koodo/build/rn/icons/IOSFR'
const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { focus: true },
      tokens: { borderColor: '#000000', borderRadius: 4 }
    },
    {
      if: { hover: true },
      tokens: { borderColor: '#666666', borderRadius: 4 }
    },
    {
      if: { pressed: true },
      tokens: { borderColor: '#666666', borderRadius: 4 }
    },
    {
      if: { focus: true, pressed: true },
      tokens: { borderColor: '#666666', borderRadius: 4 }
    }
  ],
  tokens: {
    androidENIcon: PaletteIconAndroidEN,
    androidFRIcon: PaletteIconAndroidFR,
    borderColor: 'rgba(0, 0, 0, 0)',
    borderGap: 2,
    borderRadius: 0,
    borderWidth: 1,
    iosENIcon: PaletteIconIOSEN,
    iosFRIcon: PaletteIconIOSFR,
    padding: 1
  }
}
export default theme
